import store from 'utils/store/withMiddleware'
import { propAccessor } from '@hc-frontend/utils'
import { preventOnCloseEvent } from 'core/services/onClose'

function handleSaveQuoteMultiCarrier() {
  preventOnCloseEvent()

  const multiCarrierEmailPlanIds = (this.getAttribute('data-plan-ids') || '')
    .split(',')
    .map(s => parseInt(s, 10))
    .filter(id => !isNaN(id) && id > 0)

  if (!multiCarrierEmailPlanIds.length) return

  const [firstPlanId] = multiCarrierEmailPlanIds
  const state = store.getState()

  const dentalPlanId = propAccessor(state, 'dentalAddons', [])[firstPlanId]
  const latitudeId = propAccessor(state, 'latitudeAddons', [])[firstPlanId]
  const visionPlanId = propAccessor(state, 'visionAddons', [])[firstPlanId]

  const dentalVisionTitle = [
    (state.plans[dentalPlanId] || {}).planName,
    (state.plans[visionPlanId] || {}).planName
  ]
    .filter(Boolean)
    .join(' + ')

  store.update({
    isMultiCarrierEmail: true,
    multiCarrierEmailPlanIds,
    planId: firstPlanId,
    instantQuotePlan: firstPlanId,
    dentalPlanId,
    latitudeId,
    visionPlanId,
    dentalVisionTitle
  })

  $('#emailQuoteSingular').modal('show')
}

export default handleSaveQuoteMultiCarrier
